<div class="preparation-container d-flex flex-column justify-content-center align-items-center text-center">
    <span class="counter"   >{{counter}}</span>
    <div class="title">A list of sexy audios is being prepared for you...</div>
</div>
